// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"UVeMnlTazXGT438OftnI","title":"ZWTxplNhs6unJjaLJ5oz","titleText":"d1IZgR80NRgITtEOsZn7","menu":"Rb_7V2BpQ1Uf_yWfnCbI"};